import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import Icon from "@/components/Icon";
import AdminLayout from "@/components/AdminLayout";

export default function AdminAuditLogs() {
  const [action, setAction] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    api.get("/admin/audit-logs", { params: { action: action || undefined, page, page_size: 50 } })
      .then(({ data }) => setData(data)).catch(() => {});
  }, [action, page]);
  useEffect(() => { load(); }, [load]);

  const pages = data ? Math.max(1, Math.ceil(data.total / data.page_size)) : 1;

  return (
    <AdminLayout title="Audit Logs" subtitle="Every administrator action and login attempt">
      <div className="flex items-center gap-2 mb-4">
        <div className="relative flex-1 max-w-sm">
          <Icon name="Filter" className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input data-testid="audit-filter" value={action} onChange={(e) => { setPage(1); setAction(e.target.value); }} placeholder="Filter by action (e.g. login, plan)" className="w-full rounded-xl border border-input bg-background pl-9 pr-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary/40" />
        </div>
        <span className="text-xs text-muted-foreground">{data?.total ?? 0} events</span>
      </div>

      <div className="rounded-2xl border border-border bg-card overflow-hidden" data-testid="audit-table">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted/50 text-muted-foreground"><tr>
              {["Time", "Actor", "Action", "Target", "IP"].map((h) => <th key={h} className="text-left font-semibold px-4 py-3 whitespace-nowrap">{h}</th>)}
            </tr></thead>
            <tbody>
              {!data && <tr><td colSpan={5} className="px-4 py-10 text-center"><Icon name="Loader2" className="h-6 w-6 animate-spin text-primary mx-auto" /></td></tr>}
              {data && data.items.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-muted-foreground">No audit events yet.</td></tr>}
              {data && data.items.map((l) => (
                <tr key={l.id} className="border-t border-border">
                  <td className="px-4 py-3 whitespace-nowrap text-muted-foreground">{new Date(l.created_at).toLocaleString()}</td>
                  <td className="px-4 py-3">{l.actor_email || "—"}</td>
                  <td className="px-4 py-3"><span className="font-mono text-xs px-2 py-0.5 rounded bg-muted">{l.action}</span></td>
                  <td className="px-4 py-3 text-muted-foreground">{l.target_type ? `${l.target_type}:${l.target_id || ""}` : "—"}</td>
                  <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{l.ip || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {data && pages > 1 && (
        <div className="flex items-center justify-center gap-2 mt-4">
          <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)} className="rounded-lg border border-border px-3 py-1.5 text-sm disabled:opacity-40">Prev</button>
          <span className="text-sm text-muted-foreground">Page {page} of {pages}</span>
          <button disabled={page >= pages} onClick={() => setPage((p) => p + 1)} className="rounded-lg border border-border px-3 py-1.5 text-sm disabled:opacity-40">Next</button>
        </div>
      )}
    </AdminLayout>
  );
}
